<template >
  <div v-loading="!loaded" >
    <div class="row" >
      <!-- <p>{{statFilters}}</p> -->
      <div class="col-md-12" >
        <el-row >
          <el-col :md="8" >
            <el-select
                v-model="COM.rowby"
                filterable
                fit-width
                placeholder="Select field for rows"
                clearable >
              <el-option
                  v-for="item in fieldsFilterBy('rows')"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key" ></el-option >
            </el-select >
          </el-col >
          <transition name="el-zoom-in-top" >
            <el-col
                :md="6"
                v-if="COM.pivotrender"
                type="flex" >

              <el-select
                  v-model="COM.value"
                  filterable
                  fit-width
                  placeholder="Select field for cells"
                  clearable >
                <el-option
                    v-for="item in fieldDefinitions.datas"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key" ></el-option >
              </el-select >
            </el-col >
            <el-col
                :md="6"
                v-if="COM.pivotrender"
                type="flex" >
              <el-select
                  v-model="totalAggregation"
                  filterable
                  fit-width
                  placeholder="Select total"
                  clearable >
                <el-option
                    label="Sum all"
                    value="sum" ></el-option >
                <el-option
                    label="Count no empty values"
                    value="count" ></el-option >
              </el-select >
            </el-col >
          </transition >
          <el-col :md="4" >
            <button

                class="btn btn-sm btn-success pull-right"
                title="Refresh search"
                @click="renderPivot()" >
              <i class="material-icons" >youtube_searched_for</i >
            </button >
            <button

                class="btn btn-sm btn-success pull-right"
                title="Refresh search"
                @click="renderPivot(true)" >
              <i class="material-icons" >file_download</i >
            </button >
          </el-col >
        </el-row >
        <el-row >
          <el-col :md="16" >
            <el-select
                v-model="COM.colby"
                filterable
                fit-width
                placeholder="Select field for cols"
                clearable
                multiple
                :multiple-limit="COM.pivotrender ? 1 : 0" >
              <el-option
                  v-for="item in fieldsFilterBy('cols')"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key" ></el-option >
            </el-select >
          </el-col >
          <el-col
              :md="4"
              :xs="12" >
            <el-radio-group
                v-model="COM.pivotrender"
                size="small" >
              <el-radio-button :label="true" >Pivot</el-radio-button >
              <el-radio-button :label="false" >Report</el-radio-button >
            </el-radio-group >

          </el-col >
          <el-col
              :md="4"
              :xs="12" >
            <el-radio-group
                v-model="COM.group_all_aggragators"
                size="small" >
              <el-radio-button :label="true" >Group Sums</el-radio-button >
              <el-radio-button :label="false" >Sub Sums</el-radio-button >
            </el-radio-group >
            <!--                <el-switch-->
            <!--                    v-model="COM.group_all_aggragators"-->
            <!--                    active-text="Group Sums"-->
            <!--                    inactive-text="Sums on place"-->
            <!--                ></el-switch>-->
          </el-col >
        </el-row >
        <el-row >
          <!-- <p>?=?{{ pivotFields }}</p> -->
          <el-card
              vcif="pivotData && pivotData.length"
              style="height: 100vh" >
            <sq-table
                ref="pivotTable"
                v-if="dataLoaded"
                rowKeyField="index"
                :pagging="10000"
                :addEmptyLine="false"
                :simpleLazyLoader="true"
                :cell-class-factory="pivotDecorator"
                :colDefinitions="columnsForTable"
                @cell-clicked="getDetails" ></sq-table >
          </el-card >
        </el-row >


      </div >
    </div >

    <el-dialog
        class="dark"
        append-to-body
        title="File summarised info"
        :visible.sync="detailedDialog"
        top="5vh"
        width="90%" >
      <el-row >
        <!-- <p>{{detailedData}}</p> -->
        <el-table
            :data="detailedData"
            style="width: 100%"
            height="30vh"
            v-if="detailedData"
            :simpleLazyLoader="true" >
          <el-table-column
              v-for="(col, idx) in [
              ...fieldDefinitions.datas,
              ...fieldDefinitions.pivots
            ]"
              sortable
              :key="idx"
              :prop="col.name"
              :label="col.name" ></el-table-column >
        </el-table >
      </el-row >

      <span
          slot="footer"
          class="dialog-footer" >
        <el-button @click="detailedDialog = false" >Done</el-button >
      </span >
    </el-dialog >
  </div >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import RouterEngine from "~/api/router";
import q from "querystring";

import printHtml from "~/mixins/printHtml";
import STable from "../Form/STable";
import SqTable from "../Form/SqTable";

export default {
  components: {SqTable, STable},
  mixins: [printHtml],
  data() {
    return {
      pivotCols: null,
      loaded: false,
      dataLoaded: false,
      processLog: [],
      detailedDialog: false,
      chh: "100%",
      vhhpx: 0,
      fileInfo: {},
      hotels: {},
      col_trip_w: "80px",
      selectedDate: null,
      selectedBookings: [],
      meetingpoints: [],
      resorts: [],
      flights: [],
      companies: [],
      detailedData: null,
      columns: [],
      selectedLocationId: null,
      pupResolverDialog: false,
      firstCol: null,
      notResolved: true,
      pivotData: [],
      totalAggregation: "sum",
      COM: {
        pivotrender: true,
        group_all_aggragators: true,
        colby: null,
        rowby: null,
        // from: "bookings_excrs",
        // "[Route] left join [TourCompany] on TourCompany.id=Route.coid  left join [Pup] on Route.pupAid=Pup.id  left join [Assets] on Route.asset_id=Assets.id  left  join [Contact] on Route.driver_contact_id=Contact.id ",
        where: null,
        value: null,
        // aggregate: "SUM",
        // filesearch: "",
        limit: 0
      }
    };
  },
  computed: {
    columnsForTable() {
      let idx = 0,
          incols = [];
      for (const key in this.restpivotFields) {
        if (Object.hasOwnProperty.call(this.restpivotFields, key)) {
          const fld = this.restpivotFields[key];
          incols.push({
            width: "150px",
            prop: key,
            label: fld.name ? fld.name : fld,
            formatter(val, cols, row) {
              return row[cols.prop];
            }
          });
        }
      }

      return [
        {
          fixed: "left",
          width: "150px",
          prop: this.firstDisplayField.key,
          label: this.firstDisplayField.name,
          formatter(val, cols, row) {
            // _log_("yello", val, cols, row);
            return row[cols.prop];
          }
        },
        ...incols,
        {label: "TOTAL", prop: "TOTAL", fixed: 'right'}
      ];
    },
    firstDisplayField() {
      let element = null,
          keyFount;

      for (const key in this.pivotFields) {
        if (this.pivotFields.hasOwnProperty(key)) {
          element = this.pivotFields[key];
          if (element.name == this.firstCol) {
            keyFount = key;
            break;
          }
        }
      }
      return element ? {...element, key: keyFount} : null;
    },
    restpivotFields() {
      let o = {};
      if (this.pivotCols) return this.pivotCols;

      for (const key in this.pivotFields) {
        if (this.pivotFields.hasOwnProperty(key)) {
          let element = this.pivotFields[key];
          if (element.name != this.firstCol) o[key] = element;
        }
      }
      return o;
    },
    pivotFields() {
      const vm = this;
      let r = {};
      [...this.fieldDefinitions.pivots,
       ...this.fieldDefinitions.datas].forEach(
          element => {
            r[element.key] = element;
          }
      );
      return r;

    },
    fieldDefinitions() {
      const vm = this;
      //[ScheduledTrip] left join [Transdrafts] on ScheduledTrip.id=Transdrafts.rel_object_id and rel_class='ScheduledTrip' left join  [Sappliers] on Transdrafts.sapplierId=Sappliers.id left join  [TripService] on ScheduledTrip.serviseId=TripService.id
      let o = {
        datas: [
          {
            for: ["Transfers"],
            name: "Pax",
            aggregator: "sum",
            field: "Route.pax"
          },
          {
            for: ["Transfers"],
            name: "Sell",
            aggregator: "sum",
            format: "money",
            field: "Route.cost"
          },
          // {
          //   for: "Route_",
          //   name: "Cost",
          //   field: "Route.cost",
          // },
          {
            for: ["Excursions",
                  "bookings_excrs"],
            name: "Invoiced",
            aggregator: "sum",
            format: "money",
            field: "case when Transdrafts.type=``dept`` then Transdrafts.deptamound else Transdrafts.payedamound end"
          },
          {
            for: ["Excursions",
              "bookings_excrs"],
            name: "BookedPrice",
            aggregator: "sum",
            format: "money",
            field: "Booking.bookedPrice"
          },
          // {
          //   for: ["Excursions", "Bookings"],
          //   name: "Price",
          //   field: "Transdrafts.unitcost",
          // },
          {
            for: ["Excursions",
                  "bookings_excrs"],
            name: "Pax",
            field: "Booking.adults+Booking.children",
            aggregator: "sum",
            formula: "Booking.adults+Booking.children"
          },

          {
            for: ["Transfers"],
            name: "Routes",
            aggregator: "count",
            field: "Route.routename"
          }
        ],
        pivots: [
          // {
          //   for: ["bookings_excrs"],
          //   name: "AA/Date",
          //   // totalAggregator: "count",
          //   // aggregator: "concat",
          //   field: "concat(Transdrafts.aa,FROM_UNIXTIME(Transdrafts.invoice_date,--date--))",
          //   constrain: "aa!=0 and aa is not null"
          // },
          {
            for: ["bookings_excrs"],
            name: "AA",
            // totalAggregator: "count",
            aggregator: "concat",
            field: "Transdrafts.aa",
            constrain: "aa!=0 and aa is not null"
          },
          {
            for: ["bookings_excrs"],
            name: "Ticket",
            // totalAggregator: "count",
            aggregator: "concat",
            field: "Booking.ticketNum",
            constrain: "aa!=0 and aa is not null"
          },
          {
            for: ["bookings_excrs"],
            name: "API DATE",
            // totalAggregator: "count",
            aggregator: "concat",
            field: "Transdrafts.invoice_date",
            format: "isodate",
            constrain: "aa!=0 and aa is not null"
          },
          {
            for: ["bookings_excrs"],
            name: "Booked date",
            // totalAggregator: "count",
            aggregator: "concat",
            field: "Booking.bookDate",
            format: "isodate",

          },
          {
            for: ["Excursions"],
            name: "Tags",
            field: "tags"
          },
          {
            for: ["Excursions",
                  "bookings_excrs"],
            name: "TripService",
            aggregator: "concat",
            field: "TripService.title"
            // field: "concat(TripService.title,FROM_UNIXTIME(ScheduledTrip.time,--date--))",
            // formula:"TripService.title,FROM_UNIXTIME(ScheduledTrip.time,'%d/%d/%y')"
          },
          // {
          //   for: ["Excursions", "bookings_excrs"],
          //   name: "Trip Date",
          //   // aggregator: "concat",
          //   field: "ScheduledTrip.time",
          //   format: "isodate",
          //   // formula:"TripService.title,FROM_UNIXTIME(ScheduledTrip.time,'%d/%d/%y')"
          // },
          {
            for: ["Excursions"],
            name: "Sapplier",
            field: "Sappliers.sappliername"
          },
          {
            for: null,
            name: "Trip Date",
            format: "isodate",
            aggregator: "concat-eclipse",
            totalAggregator: "unique-count",
            field:
                this.$route.query.pivotctx == "Transfers"
                    ? "Route.date"
                    : "ScheduledTrip.time"
          },
          {
            for: null,
            name: "Month",
            format: "month",
            // totalAggregator: "count",
            field:
                this.$route.query.pivotctx == "Transfers"
                    ? "Route.date"
                    : "ScheduledTrip.time"
          },
          {
            for: ["Transfers",
                  "bookings_excrs"],//
            name: "TourCompany",
            field: "TourCompany.coname",
            details: "coname",
            aggregator: "concat",
            totalAggregator: "count",
          },
          {
            for: ["Transfers"],
            name: "Agent",
            aggregator: "count",
            field: "Route.distributors"
          },
          {
            for: ["bookings_excrs"],
            name: "Rep",
            aggregator: "concat",
            field: "Rep.name"
          },
          {
            for: ["bookings_excrs"],
            name: "Inv.Type",
            aggregator: "concat",
            field: "Transdrafts.type"
          },
          // {
          //   for: ["Transfers"],
          //   name: "Bus Sign",
          //   field: "Route.bussign"
          // },
          // {
          //   for: ["Transfers"],
          //   name: "Start Tm.",
          //   field: "startTimeMM"
          // },
          // {
          //   for: ["Transfers"],
          //   name: "Flight",
          //   field: "Route.flight"
          // },
          {
            for: ["Transfers"],
            name: "Trans Type",
            aggregator: "concat",
            field: "Route.destination"
          },
          {
            for: ["Transfers"],
            name: "Trans Dir",
            aggregator: "concat",
            field: "Route.direction"
          },
          // {
          //   for: ["Transfers"],
          //   name: "Start Point",
          //   field: "Pup.name",
          //   details: "name"
          // },
          // {
          //   for: ["Transfers"],
          //   name: "Route",
          //   field: "locseq"
          // },
          {
            for: ["Transfers"],
            name: "Vehicle",
            aggregator: "concat-eclipse",
            totalAggregator: "unique-count",
            field: "Assets.name"
          },
          {
            for: ["Transfers"],
            name: "Driver",
            aggregator: "concat",
            field: "Contact.name"
          }
        ]
      };
      return {
        pivots: o.pivots
                 .filter(e => !e.for || e.for.indexOf(vm.$route.query.pivotctx) >= 0)
                 .map(element => {
                   if (!element.key) {
                     const key = element.name.replace(/[^a-zA-Z0-9+]/g, "_");
                     element.key = key;
                   }
                   element.ismain = false;
                   return element;
                 }),
        datas: o.datas
                .filter(e => !e.for || e.for.indexOf(vm.$route.query.pivotctx) >= 0)
                .map(element => {
                  if (!element.key) {
                    const key = element.name.replace(/[^a-zA-Z0-9+]/g, "_");
                    element.key = key;
                  }
                  element.ismain = true;
                  return element;
                })
      };
    },

    pivotctx: {
      get() {
        return this.$route.query.pivotctx ? this.$route.query.pivotctx : null;
      },
      set(v) {
        this.routeGo({query: {pivotctx: v}});
      }
    },
    // fuelReadings() {
    //   var x = this.getList("readings");
    //   _log_("n....", x);
    //   return x;
    // },
    ...mapGetters({
      statFilters: "user/statFilters"
    })
  },
  watch: {
    "COM.rowby"(v, vo) {
      if (v != vo && v != this.$route.query.rowby)
        this.routeGo({query: {rowby: v}}, true);
    },
    "$route.query.rowby"(v, vo) {
      if (v != vo && v != this.COM.rowby) this.COM.rowby = v;
    },
    "COM.colby"(v, vo) {
      if (v != vo && v != this.$route.query.colby)
        this.routeGo({query: {colby: v.join(",")}}, true);
    },
    "$route.query.colby"(v, vo) {
      if (v != vo && v != this.COM.colby.join(","))
        this.COM.colby = v.split(",");
    },
    "COM.value"(v, vo) {
      if (v != vo && v != this.$route.query.value)
        this.routeGo({query: {value: v}}, true);
    },
    "$route.query.value"(v, vo) {
      if (v != vo && v != this.COM.value) this.COM.value = v;
    },
    "COM.pivotrender"(v, vo) {
      if (v != vo && v && this.COM.colby && this.COM.colby.length > 1)
        this.COM.colby = [this.COM.colby[0]];
      if (v != vo && v != this.$route.query.pivotrender)
        this.routeGo({query: {pivotrender: v}}, true);
    },

    "$route.query.pivotrender"(v, vo) {
      if (v != vo && v != this.COM.pivotrender) this.COM.pivotrender = v;
    },
    "COM.group_all_aggragators"(v, vo) {
      if (v != vo && v != this.$route.query.group_all_aggragators)
        this.routeGo({query: {group_all_aggragators: v}}, true);
    },
    "$route.query.group_all_aggragators"(v, vo) {
      if (v != vo && v != this.COM.group_all_aggragators)
        this.COM.group_all_aggragators = v;
    },
    //  "COM.pivotctx"(v, vo) {
    //   if (v != vo && v != this.$route.query.pivotctx)
    //     this.routeGo({ query: { pivotctx: v } }, true);
    // },
    // "$route.query.pivotctx"(v, vo) {
    //   if (v != vo && v != this.COM.pivotctx) this.COM.pivotctx = v;
    // },
    "$route.query.execute"(v, vo) {
      if (v != vo && v == "search") {
        this.renderPivot();
        this.routeGo({query: {execute: "no"}}, true);
      }
      if (v != vo && v == "download") {
        this.renderPivot(true);
        this.routeGo({query: {execute: "no"}}, true);
      }
    },
    statFilters: {
      handler(val) {
        // _log_("n..IN..", val);
        // delete this.COM.daterange;
        this.COM = {...this.COM, ...val, from: "bookings"};
        // _log_("n..OUT..", this.COM);
      },
      deep: true
    }
  },
  methods: {
    pivotDecorator(data) {
      // _log_('pivotDecorator', data.value)
      return data.value && data.value != '0' && this.COM.pivotrender ? 'clickme' : null
    },
    fieldsFilterBy(ctx) {
      const vm = this;
      let o = null;
      const rowO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COM.rowby
          }),
          colO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COM.colby
          });
      if (ctx == "cols")
        o = this.fieldDefinitions.pivots.filter(
            e => !rowO || e.field != rowO.field
        );
      if (ctx == "rows")
        o = this.fieldDefinitions.pivots.filter(
            e => !colO || e.field != colO.field
        );
      return o;
    },
    // downloadExcel() {
    //   api.ajax_download("transdrafts/vuegetlist", {
    //     ...this.qTransactions,
    //     download: 1,
    //   });
    // },
    async renderPivot(excel) {
      this.loaded = false;
      this.dataLoaded = false;
      this.firstCol = JSON.parse(JSON.stringify(this.COM.rowby));
      _log_(
          "sss...renderPivot.",
          this.fieldDefinitions.pivot,
          this.COM,
          rowO
      );
      // pipeActions(['=>route/pivot','->renderPivot'],COM);

      switch (this.pivotctx) {
        case "Transfers":
          this.COM.from = "routes";
          break;
        case "Excursions":
          this.COM.from = "trips";
          break;
        case "Bookings":
          this.COM.from = "bookings";
          break;
        default:
          break;
      }

      // this.COM.from = this.pivotctx == "Transfers" ? "routes" : "trips";
      const vm = this,
          rowO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COM.rowby
          });
      let colO = null;
      // this.COM.colby_field = [];
      // this.COM.colby.forEach((element) => {
      //   colO = vm.findInArray(vm.fieldDefinitions.pivots, {
      //     name: element,
      //   });
      //   if (colO) {
      //     vm.COM.colby_field.push(colO.field);
      //     vm.COM.colby_format = colO.format;
      //   }
      // });
      // this.COM.value_field = this.pivotFields;
      // this.COM.rowby_field = JSON.stringify(rowO);
      // this.COM.rowby_format = rowO.format;

      if (excel) {
        api.ajax_download("transdrafts/pivot", {
          ...this.COM,
          ...this.$route.query,
          pivotFields: JSON.stringify(this.pivotFields),
          download: 1
        });
        this.dataLoaded = true;
        this.loaded = true;
        // return;
      }
      const {data} = await api.fetchProcessor("transdrafts/pivot", {
            ...this.COM,
            ...this.$route.query,
            pivotFields: JSON.stringify(this.pivotFields)
          }),
          VMO = this;

      if (!data) return;
      this.pivotData = null;
      let rs = data.results,
          rc = null;
      let fd = _.find(this.fieldDefinitions.pivots, {
        name: VMO.COM.rowby
      });

      // if (fd) rc = { field: fd.field.replace(".", "_"), name: fd.name };
      // else rc = VMO.COM.rowby.replace(".", "_");

      if (VMO.columns.length > 0) VMO.columns.splice(0, VMO.columns.length);
      this.pivotCols = data["cols"];
      // VMO.columns.push(rc);
      // if (this.COM.pivotrender) this.pivotCols = data["cols"];
      // else this.pivotCols = null;
      // {

      //   var sample = rs[0];
      //   const allFields = [
      //     ...this.fieldDefinitions.pivots,
      //     ...this.fieldDefinitions.datas,
      //   ].map((e) => {
      //     return {
      //       field: e.field.replace(".", "_"),
      //       name: e.name,
      //       aggregate: !!e.name.aggregator,
      //     };
      //   });
      //   for (const key in sample) {
      //     if (sample.hasOwnProperty(key) && key != this.COM.rowby) {
      //       if (!VMO.COM.pivotrender) {
      //         const colf = this.findInArray(allFields, { field: key });
      //         if (colf) VMO.columns.push(colf);
      //       } else if (fd && fd.field == key) VMO.columns.push(fd);
      //       else VMO.columns.push(key);
      //     }
      //   }
      // }
      // var excludeProp = VMO.COM.rowby.replace(".", "_");
      if (VMO.COM.pivotrender) {
        //add total column

        const cellDirective = vm.findInArray(vm.fieldDefinitions.datas, {
          name: this.$route.query.value,
        });

        //parse results
        rs.forEach(row => {
          let sum = 0;
          for (const key in row) {


            if (VMO.COM.rowby != key && row.hasOwnProperty(key)) {
              sum += parseFloat(row[key]);
              if (cellDirective.format == 'money')
                row[key] = this.$theMoney(row[key]);
              else
                row[key] = row[key]; // parseFloat(row[key]).toFixed(2);
            }
          }

          row.TOTAL = parseFloat(sum)
              .toFixed(2);
        });
      }
      this.dataLoaded = true;
      this.$nextTick(() => {
        _log_('colDirective', rs)
        this.$refs.pivotTable.wakeUp(rs);
      });

      // this.$refs.pivotTable.appendTrackedData(rs);
      // this.$refs.pivotTable.wakeUp(rs);
      // this.pivotData = rs;
      // _log_(
      //   "sss....",
      //   VMO.columns,
      //   VMO.pivotData,
      //   VMO.COM.rowby.replace(".", "_")
      // );

      this.loaded = true;
    },
    getSummaries(param) {
      this.loaded = false;
      const {columns, data} = param;
      const sums = [];
      const doaggr = this.totalAggregation;
      _log_(">>>>", doaggr);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Grand Total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              if (doaggr == "sum") return prev + curr;
              else return prev + (curr != 0 ? 1 : 0);
            }
            else {
              return prev;
            }
          }, 0);
        }
        else {
          sums[index] = "N/A";
        }
      });
      this.loaded = true;
      return sums;
    },
    dbg(msg) {
      _log_("VDBG:", msg);
    },
    // confirmLocationResolution() {
    //   notResolved = false;
    // },
    async getDetails(clickData) {
      if (!(clickData.value && clickData.value != '0' && this.COM.pivotrender)) return
      this.loaded = false;
      const vm = this,
          whatRow = this.fieldsFilterBy("rows")
                        .filter(
                            e => e.key == vm.COM.rowby
                        )[0].field,
          whatCol = this.fieldsFilterBy("cols")
                        .filter(
                            e => e.key == vm.COM.colby
                        )[0].field;
      _log_(">>whatCol>", whatRow, whatCol);
      const {data} = await api.fetchProcessor("transdrafts/pivot", {
        from: this.COM.from,
        cond1: vm.COM.rowby, //whatRow,
        rowby_format: this.COM.rowby_format,
        colby_format: this.COM.colby_format,

        val1: clickData.row[this.COM.rowby],
        cond2: vm.COM.colby, //whatCol,
        val2: this.pivotCols[clickData.column.property], //get real col value since the prop is santised (due to problem with json keys)
        ...this.$route.query,
        pivotFields: JSON.stringify(this.pivotFields)
      });
      //
      //
      _log_(">getDetails>>", data);
      this.detailedData = data.results;
      this.detailedDialog = true;
      this.loaded = true;
    }
  },
  mounted: function () {
    if (this.$route.query.colby)
      this.COM.colby = this.$route.query.colby.split(",");
    if (this.$route.query.rowby) this.COM.rowby = this.$route.query.rowby;
    if (this.$route.query.value) this.COM.value = this.$route.query.value;
    if (this.$route.query.pivotrender)
      this.COM.pivotrender =
          this.$route.query.pivotrender &&
          this.$route.query.pivotrender != "false";
    this.loaded = true;
  }
};
</script >

<style >
.staticDisplay {
  position: fixed;
  background-color: ghostwhite;
  z-index: 10;
}

.vehicle-slot {
  padding: 3px;
}

.vehicle-slot.rselected {
  box-shadow: 0px 0px 5px;
  border: 1px dotted blue;
}

.routing-slot {
  padding: 3px;
}

.routing-slot.rselected {
  box-shadow: 0px 0px 5px;
  border: 1px dotted blue;
}

.flip-list-move {
  transition: transform 1s;
}

.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

.sunny
.clickme {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
}

.dark
.clickme {
  color: #e8d4b8;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
}

.vstopped {
  background-color: goldenrod !important;
}

.selectedElement {
  color: black;
  padding: 2px;
  box-shadow: 0px 2px 4px gray;
  /* margin-bottom: 5px; */
  margin-left: 3px;
  background-color: #ffffff;
}

span.title {
  font-weight: bold;
  font-size: 11px;
}

span.info {
  color: grey;
  font-size: 9px;
}

div.active {
  height: 24px;
  padding-left: 3px;
  line-height: 1;
  margin-bottom: 2px;
  background-color: aquamarine;
}

div.freezed {
  height: 24px;
  line-height: 1;
  padding-left: 3px;
  margin-bottom: 2px;
  background-color: midnightblue;
  color: wheat;
}

.el-autocomplete-suggestion li {
  padding: 2px !important;
}
</style >
